var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSponsored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6919 4.31547C13.7306 4.44547 13.75 4.58047 13.75 4.7161V11.8892C13.7499 12.1081 13.6988 12.3239 13.6006 12.5196C13.5024 12.7152 13.3599 12.8852 13.1844 13.016C13.009 13.1469 12.8054 13.235 12.5899 13.2733C12.3744 13.3116 12.1529 13.2991 11.9431 13.2367L8.49687 12.2117C8.25294 12.7092 7.8507 13.1117 7.35332 13.3558C6.85593 13.6 6.29154 13.6721 5.74874 13.5608C5.20593 13.4496 4.71545 13.1612 4.35426 12.741C3.99307 12.3208 3.78163 11.7926 3.75312 11.2392L3.75 11.1142L3.74937 10.8017L2.25563 10.3573C1.96501 10.271 1.71009 10.093 1.52887 9.84994C1.34765 9.60689 1.24983 9.31177 1.25 9.0086V7.59547C1.25014 7.29243 1.34818 6.99754 1.5295 6.75473C1.71082 6.51191 1.96572 6.33417 2.25625 6.24797L11.9437 3.36922C12.3011 3.26309 12.686 3.30322 13.0138 3.48078C13.3416 3.65833 13.5855 3.95879 13.6919 4.3161V4.31547ZM4.68687 11.0798L4.6875 11.1136C4.68717 11.4534 4.79763 11.7841 5.00213 12.0555C5.20664 12.3268 5.49405 12.5242 5.82079 12.6175C6.14753 12.7109 6.4958 12.6951 6.8128 12.5727C7.12981 12.4503 7.39827 12.2279 7.5775 11.9392L4.68687 11.0798Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsored);
export default __webpack_public_path__ + "static/media/sponsored.91ef0626a0070ed905a78369f8eee5d7.svg";
export { ForwardRef as ReactComponent };